import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { isNoticeAcknowledged, acknowledgeNotice } from '../../analytics/consent';
import styles from './CookieConsentBanner.module.css';

/**
 * Informational cookie notice.
 *
 * Analytics (PostHog + Google Analytics) load immediately on page load; this
 * banner informs the user and lets them dismiss it. It does not gate the
 * trackers. Users can opt out via their browser settings (described in the
 * Privacy Policy).
 *
 * Mounted once at the app root (see App.tsx). Re-open it from anywhere with
 * openCookieSettings() from analytics/consent.ts.
 */
export default function CookieConsentBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!isNoticeAcknowledged()) setVisible(true);

        // Allow a "Cookie notice" link to re-open the banner.
        const reopen = () => setVisible(true);
        window.addEventListener('cvl:cookie-settings', reopen);
        return () => window.removeEventListener('cvl:cookie-settings', reopen);
    }, []);

    const dismiss = () => {
        acknowledgeNotice();
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className={styles.banner} role="region" aria-label="Cookie notice">
            <div className={styles.inner}>
                <div className={styles.text}>
                    <p className={styles.title}>Cookies &amp; analytics</p>
                    <p className={styles.body}>
                        We use strictly necessary cookies to keep you signed in, plus analytics
                        to improve the platform. By continuing you agree. You can opt out in your
                        browser settings. See our{' '}
                        <Link to="/privacy" className={styles.link}>
                            Privacy Policy
                        </Link>
                        .
                    </p>
                </div>
                <div className={styles.actions}>
                    <button type="button" className={styles.accept} onClick={dismiss}>
                        Got it
                    </button>
                </div>
            </div>
        </div>
    );
}
